var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Colors } from '@doordash/design-language';
import styled from 'styled-components';
export var INPUT_WIDTH_LARGE = 360;
export var INPUT_WIDTH_MEDIUM = 230;
export var InputContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: ", "px;\n"], ["\n  max-width: ",
    "px;\n"])), function (p) {
    return p.size === 'large' ? INPUT_WIDTH_LARGE : INPUT_WIDTH_MEDIUM;
});
export var Separator = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border-top: 1px solid ", ";\n"], ["\n  border-top: 1px solid ", ";\n"])), Colors.BorderPrimary);
var templateObject_1, templateObject_2;
